<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('woff-to-ttf-converter', 'WOFF → TTF');

function handleBatchCreated(batchId: string) {
  console.log('[WOFF-to-TTF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[WOFF-to-TTF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[WOFF-to-TTF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[WOFF-to-TTF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[WOFF-to-TTF Converter] Credits updated:', credits);
}
</script>
